import React, { Component } from "react";
import '../rnr.css';
import arch_diagram from '../architecture.png';

class About extends Component {
  render() {
    return (
      <main className="flex-shrink-0">
        <div className="container">
          <h4 className="mt-3">About</h4>
          <p className="lead">Prototype that demonstrates several steps of Meucci's 10 step Advanced Risk and Portfolio Management
          framework using a React Single Page Application (SPA).</p>
          <img
                  alt="Cloud Architecture Diagram"
                  src={arch_diagram}
                  width="781"
                  height="553"

                />
        </div>
      </main>
    );
  }
}
 
export default About;